import { TransportActiveDocumentDetail } from '../../TransportActiveDocument/views/TransportActiveDocumentUpdateView';

export default function SupplierTransportActiveDocumentDetail() {
  return (
    <TransportActiveDocumentDetail
      isSupplierDdt={true}
      translationPrefix="pages.supplier-active-ddt.detail"
    />
  );
}
